import { useEffect } from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import "styles/scss/sitemap.scss";

const Sitemap = ({ isOpen, onClose }) => {
  // isOpen 상태에 따라 body의 스크롤을 제어
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("no-scroll"); // 스크롤 제거
    } else {
      document.body.classList.remove("no-scroll"); // 스크롤 복원
    }

    // 컴포넌트가 언마운트될 때 스크롤 복원
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div className="sitemap-overlay" onClick={onClose}></div>

      <motion.div
        initial={{ x: "100%" }}
        animate={{ x: 0 }}
        exit={{ x: "100%" }}
        transition={{ duration: 0.3 }}
        className="sitemap-sidebar"
      >
        {/* 닫기 버튼 */}
        <button className="sitemap-close" onClick={onClose}>
          <X size={24} />
        </button>

        {/* 사이트맵 리스트 */}
        <h3 className="sitemap-title"> 사이트맵</h3>
        <ul className="sitemap-list">
          <li>
            <div>
                <p>회사소개</p>
                <a href="/about" className="sitemap-list-hover margin-bottom">비전,연혁</a>
                <a href="about/organization/:aboutId" className="sitemap-list-hover padding-bottomS">조직도</a>
            </div>
          </li>
          <li>
          <div>
              <p>실제적용사례[재난안전 / 교육기관 /<br />위치기반&IoT / 스마트팜 / 기타]</p>
              <a href="/business" className="sitemap-list-hover padding-bottomS">비즈니스</a>
          </div>
          </li>
          <li>
          <div>
              <p>[보도자료 / 공지사항 / 갤러리 ]</p>
              <a href="/news" className="sitemap-list-hover padding-bottomS">N 소식</a>
          </div>
          </li>
          <li>
          <div>
              <p>[인재상 / 복리후생 ]</p>
              <a href="/recruitment" className="sitemap-list-hover padding-bottomS">인재채용</a>
          </div>
          </li>
        </ul>
        <div className="adress-sitemap">
          <div className="n-logo"></div>
          <p>(44921)울산광역시 울주군 범서읍 대리로 89 <br></br>경동빌딩 2~5층</p>
          <p>Tel. 052-246-1331</p>
          <p>Fax. 052-246-1991</p>
          <p className="gray">© Ntek. All Rights Reserved.</p>
        </div>
      </motion.div>
    </>
  );
};

export default Sitemap;
